import axios from "axios";
import { deleteCookie, getCookie, setCookie } from "./cookie";
import { api } from "../api/api_route";
import { useNavigate } from "react-router-dom";

export const handleAuthentication = async (error) => {
  if (error?.config?.url.includes("refreshToken")) {
    resetDataAndLogout();
    window.location.href = "/";
    return Promise.reject(error);
  } else {
    const refreshSuccessful = await getRefreshToken();
    if (refreshSuccessful) {
      const newAccessToken = getCookie("accessToken");
      error.config.headers.Authorization = `Bearer ${newAccessToken}`;
      return axios(error.config);
    } else {
      return Promise.reject(error);
    }
  }
};

export const getRefreshToken = async (errorConfig) => {
  const currentRefreshToken = getCookie("refreshToken");
  try {
    const headerToken = `Bearer ${currentRefreshToken}`;



    const refreshTokenResult = await axios.post(
      `${api}/users/refreshToken`,
      {},
      {
        headers: {
          Authorization: headerToken,
        },
      }
    );

    if (refreshTokenResult?.data) {
      try {
        await setLoginCookies(refreshTokenResult.data);
        return true;
      } catch (err) {
        console.log(err);
      }
    }
    else {
      window.location.href = '/login';
      return false;
    }
  } catch (error) {
    const newRefreshToken = getCookie("refreshToken");
    if (newRefreshToken && newRefreshToken !== currentRefreshToken) {
      return true; // Token was refreshed in parallel by another tab
    }

    resetDataAndLogout();
    window.location.href = '/login';
    return false;
  }
};

export const setLoginCookies = async (user) => {
  try {
    const defaultExpires = 30 * 60;
    if (!user || !user.accessToken || !user.refreshToken) {
      throw new Error("Invalid user object or missing tokens");
    }

    const accessToken = String(user.accessToken);
    const refreshToken = String(user.refreshToken);
    const accessExpiresIn = String(user.accessExpiresIn);
    const refreshExpiresIn = String(user.refreshExpiresIn);

    const accessExpiration = Number(user.accessExpiresIn) || defaultExpires;
    const refreshExpiration = Number(user.refreshExpiresIn) || defaultExpires * 48;

    await setCookie("accessToken", accessToken, accessExpiration);
    await setCookie("accessExpiresIn", accessExpiresIn, accessExpiration);
    await setCookie("refreshToken", refreshToken, refreshExpiration);
    await setCookie("refreshExpiresIn", refreshExpiresIn, refreshExpiration);

  } catch (err) {
    console.error('[setLoginCookies] Error setting login cookies:', err);
    throw err;
  }
};

export const setNewRegisterCookies = (user) => {
  if (!user.token) {
    console.error("Token is missing, cannot set cookie");
    return;
  }

  setCookie("registerNewAccessToken", user.token, user.expiresIn);
};

export const resetDataAndLogout = () => {
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      ?.replace(/^ +/, "")
      ?.replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};
